var styleDataHash = "493e4775";
const injectCss = (() => {
  var css = `.XPVyK,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.aqBCx{align-items:center;background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-color-text-standard-primary,var(--wsr-color-D10,#000624));cursor:pointer;display:flex;min-height:36px;padding-block:var(--ricos-internal-list-item-select-padding-block,6px);padding-inline:var(--ricos-internal-list-item-select-padding-inline,18px);--wds-color-text-standard-secondary:var(
    --wds-list-item-select-subtitle,var(--wsr-color-D40,#868aa5)
  )}.aqBCx:hover{background-color:var(--wds-list-item-select-fill-hover,var(--wsr-color-B50,#e7f0ff))}.aqBCx.Dg-AV,.aqBCx:active{background-color:var(--wds-list-item-select-active-fill,var(--wsr-color-B10,#116dff));--wds-color-text-standard-primary:var(
    --wds-list-item-select-active-title,var(--wsr-color-D80,#fff)
  );--wds-color-text-standard-secondary:var(
    --wds-list-item-select-active-subtitle,var(--wsr-color-D80,#fff)
  )}.aqBCx.Dg-AV:hover{background-color:var(--wds-list-item-select-active-fill-hover,var(--wsr-color-B20,#5999ff))}.aqBCx.md4Im{background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-list-item-select-title-disabled,var(--wsr-color-D10-30,rgba(0,6,36,.3)));cursor:auto;pointer-events:none}.aqBCx:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.aqBCx.vMiD7{--wds-font-size-body-medium:16px}.aqBCx.kn3P-{min-height:54px}.AVe-x{column-gap:6px;display:grid;flex:1;grid-template-areas:"prefix title suffix";grid-template-columns:max-content 1fr max-content;grid-template-rows:auto auto}.kn3P-{grid-template-areas:"prefix title suffix" "prefix subtitle suffix"}.-vw1K{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:prefix}.Bh4Ko{align-self:center;grid-area:title}.Bh4Ko,.ucs6y{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ucs6y{grid-area:subtitle}.iqKog{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:suffix}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var list_item_select_default = {
  "fontElementMap": "XPVyK",
  "root": "aqBCx",
  "selected": "Dg-AV",
  "disabled": "md4Im",
  "mobile": "vMiD7",
  "withSubtitle": "kn3P-",
  "content": "AVe-x",
  "prefix": "-vw1K",
  "title": "Bh4Ko",
  "subtitle": "ucs6y",
  "suffix": "iqKog"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
